
export enum VldGroupState {
  // Before the group has checked the data for the first time.
  Uninitialized = 0,
  // Incomplete/errored group where user has not pressed "Next" yet.
  Naive,
  // Incomplete/errored group where user has pressed "Next" and errors are now being reported.
  Errors,
  // All fields are complete, Next is enabled.
  Ready,
  // The group was completed, and Next pressed. Next is now invisible and next group(s) are active.
  Done
}
export interface VldGroupDirectiveInterface {
  onMessagesChanged(): void;
  getState(): VldGroupState;
}
;
